import type { AuthUser } from '@/features/auth/types';

export function isPhoneNumberMissing(
  user: Pick<AuthUser, 'phoneNumber'> | null | undefined,
): boolean {
  if (!user) return false;
  return !user.phoneNumber?.trim();
}
